import { reducerWithInitialState } from 'typescript-fsa-reducers';

import { getDefaultNetworkStatus } from '@utils';

import { menuCatalogFetchListReducer } from './actions';

import { IMenuCatalogStore } from './types';

export const getMenuCatalogInitialState = (): IMenuCatalogStore => ({
	items: {
		data: {
			list: [],
		},
		meta: {
			networkStatus: getDefaultNetworkStatus(),
		},
	},
});

export const menuCatalog = reducerWithInitialState<IMenuCatalogStore>(getMenuCatalogInitialState());

menuCatalogFetchListReducer(menuCatalog);
